import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import { COLLABORATORS, SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import AvatarTooltip from "@Shared/components/general/avatar-tooltip";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReminderItem",
  components: {
    AvatarTooltip,
    DatepickerInput
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    scheduledDate: {
      type: String,
      required: true
    },
    scheduledTime: {
      type: String,
      required: true
    },
    assignees: {
      type: Array,
      required: true
    },
    complete: {
      type: Boolean,
      default: false
    },
    classification: {
      type: String,
      required: true
    },
    parentPopoverSelector: {
      type: String,
      default: ".inline-followup"
    }
  },
  data() {
    return {
      scheduledDatePopoverOpen: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AgentStore", {
    agents(state) {
      const {
        agents
      } = state;
      if (!agents) return {};
      return agents.byId;
    }
  })), mapGetters("BoardStore", [COLLABORATORS, SELECTED_BOARD])), {}, {
    activityDescriptionTooltipOptions() {
      return {
        title: this.description,
        delay: {
          show: 500,
          hide: 100
        },
        placement: "right",
        boundary: "viewport"
      };
    },
    firstThreeAssignees() {
      var _context;
      return _sliceInstanceProperty(_context = this.assigneesValues).call(_context, 0, 3);
    },
    assigneesValues() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.assignees).call(_context2, assigneeUsername => {
        const collaborator = this.allCollaborators && this.allCollaborators[assigneeUsername];
        return collaborator;
      });
    },
    calendarInfo() {
      return this.$options.filters.parseReminderClassificationTimeAgo(this.scheduledDate, this.scheduledTime, true);
    },
    calendarClass() {
      return this.$options.filters.parseReminderClassificationClass(this.scheduledDate, this.scheduledTime);
    },
    formattedScheduledTime() {
      return this.$options.filters.basicFormatTimeFromTime(this.scheduledTime);
    },
    selectedBoardId() {
      return this.SELECTED_BOARD.id;
    },
    currentUsername() {
      return this.SELECTED_BOARD.agentUsername;
    },
    allCollaborators() {
      const currentCollaborators = this.COLLABORATORS(this.selectedBoardId);
      return _objectSpread(_objectSpread({}, this.agents), currentCollaborators);
    }
  }),
  methods: {
    handleMarkAsComplete() {
      this.$emit("reminder-complete", {
        complete: !this.complete,
        id: this.id,
        description: this.description,
        scheduledDate: this.scheduledDate,
        scheduledTime: this.scheduledTime
      });
    },
    handleScheduledDateChange(value) {
      this.$emit("change", {
        complete: this.complete,
        id: this.id,
        description: this.description,
        scheduledTime: this.scheduledTime,
        scheduledDate: value
      });
      this.hideScheduledDatePopover();
    },
    hideScheduledDatePopover() {
      this.scheduledDatePopoverOpen = false;
    },
    getPopoverTarget() {
      return this.$refs.popoverTarget;
    }
  }
});